const annotationPrefixes = [
    '[the learner interrupted ',
    '[the user interrupted ',
    '[learner interrupted ',
];
const internalAnnotation = /^\[(?:the )?(?:learner|user) interrupted (?:this|the) (?:answer|response);[^\]\r\n]{0,220}\]$/i;
/** Filter legacy internal delivery annotations before text reaches chat or speech. */
export class MioVisibleTextFilter {
    pending = '';
    codeDelimiter = null;
    delimiterRun = '';
    delimiterAtLineStart = false;
    delimiterEscaped = false;
    lineIndent = 0;
    lineIsBlank = true;
    closingFence = false;
    backslashes = 0;
    finishDelimiterRun() {
        if (!this.delimiterRun)
            return;
        const character = this.delimiterRun[0] ?? '';
        const length = this.delimiterRun.length;
        if (this.codeDelimiter) {
            if (character === this.codeDelimiter.character) {
                if (this.codeDelimiter.fenced) {
                    // A fence closes on its own line, never inside a code string or comment.
                    this.closingFence = this.delimiterAtLineStart && length >= this.codeDelimiter.length;
                }
                else if (length === this.codeDelimiter.length)
                    this.codeDelimiter = null;
            }
        }
        else if (!this.delimiterEscaped) {
            const fenced = this.delimiterAtLineStart && length >= 3;
            if (character === '`' || fenced)
                this.codeDelimiter = { character, length, fenced };
        }
        this.delimiterRun = '';
    }
    observeVisible(text) {
        for (const character of text) {
            if (character === '`' || character === '~') {
                if (this.delimiterRun && !this.delimiterRun.startsWith(character))
                    this.finishDelimiterRun();
                if (!this.delimiterRun) {
                    this.delimiterAtLineStart = this.lineIndent !== null && this.lineIndent <= 3;
                    this.delimiterEscaped = this.backslashes % 2 === 1;
                    this.closingFence = false;
                }
                this.delimiterRun += character;
            }
            else
                this.finishDelimiterRun();
            if (character === '\n') {
                if (this.closingFence || (this.lineIsBlank && !this.codeDelimiter?.fenced))
                    this.codeDelimiter = null;
                this.closingFence = false;
                this.lineIndent = 0;
                this.lineIsBlank = true;
            }
            else {
                if (!/[ \t\r]/.test(character)) {
                    this.lineIsBlank = false;
                    if (character !== '`' && character !== '~')
                        this.closingFence = false;
                }
                this.lineIndent =
                    character === ' ' && this.lineIndent !== null ? this.lineIndent + 1 : null;
            }
            this.backslashes = character === '\\' ? this.backslashes + 1 : 0;
        }
    }
    push(delta) {
        let source = this.pending + delta;
        this.pending = '';
        let visible = '';
        while (source) {
            const start = source.indexOf('[');
            if (start < 0) {
                this.observeVisible(source);
                return visible + source;
            }
            const before = source.slice(0, start);
            visible += before;
            this.observeVisible(before);
            this.finishDelimiterRun();
            source = source.slice(start);
            const lower = source.toLowerCase();
            const possible = annotationPrefixes.some((prefix) => lower.startsWith(prefix) || prefix.startsWith(lower));
            if (possible && !this.codeDelimiter) {
                const end = source.indexOf(']');
                if (end < 0 && source.length <= 280 && !source.includes('\n')) {
                    this.pending = source;
                    return visible;
                }
                if (end >= 0 && internalAnnotation.test(source.slice(0, end + 1))) {
                    source = source.slice(end + 1);
                    continue;
                }
            }
            visible += '[';
            this.observeVisible('[');
            source = source.slice(1);
        }
        return visible;
    }
    finish() {
        const pending = this.pending;
        this.pending = '';
        // An interrupted generation can itself stop halfway through the private marker.
        return annotationPrefixes.some((prefix) => pending.toLowerCase().startsWith(prefix))
            ? ''
            : pending;
    }
}
export function stripMioInternalAnnotations(text) {
    const filter = new MioVisibleTextFilter();
    return filter.push(text) + filter.finish();
}
